module.exports = __webpack_public_path__ + "img/598 1.1a5e3547.png";